import "./App.css";
import  Navbar  from "./components/Navbar/Navbar";
import { Route, Routes, useLocation } from "react-router-dom";
import { AuthenticationGuard } from "./components/authentication-guard";
import Dashboard from "./components/Dashboard/Dashboard";
import DealerDashboard from "./components/DealerDashboard";
import TransactionHistory from "./components/TransactionHistory/TransactionHistory";
import Transaction from "./components/Transaction/Transaction";
import Team from "./components/Team/Team";
import Invite from "./components/Invite/Invite";
import FinanceAmount from "./components/FinanceAmount/FinanceAmount";
import UploadDocuments from "./components/UploadDocuments/UploadDocuments";
import TransactionSummary from "./components/TransactionSummary/TransactionSummary";
import Confirmation from "./components/Confirmation/Confirmation";
import DealershipSignup from "./components/DealershipSignup/DealershipSignup";
import LoanData from "./components/LoanData/LoanData";
import GuestLoanDeatils from "./components/GuestLoanDeatils/GuestLoanDeatils";
import Payments from "./components/Payments/Payments";
import React from 'react'
import DraftingInstructions from "./components/PaymentsDraft/PaymentsDraft";
import Auth0TokenMiddleware from "./Auth0TokenMiddleware";


function App() {
  const location = useLocation();
  const hideNavbarRoutes = ["/loan-data", "/guest-loan-details", "/signup"];
  const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);

  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     event.preventDefault();
  //     event.returnValue = ''; // Required for Chrome
  //   };

  //   window.addEventListener('beforeunload', handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, []);
  const routes = (
    <Routes>
      <Route
        path="/"
        element={<AuthenticationGuard component={DealerDashboard} />}
      />
      <Route
        path="/dealer-dashboard"
        element={<AuthenticationGuard component={Dashboard} />}
      />
      <Route
        path="/transaction-history"
        element={<AuthenticationGuard component={TransactionHistory} />}
      />
      <Route
        path="/transaction"
        element={<AuthenticationGuard component={Transaction} />}
      />
      <Route
        path="/team"
        element={<AuthenticationGuard component={Team} />}
      />
      <Route
        path="/invite"
        element={<AuthenticationGuard component={Invite} />}
      />
      <Route
        path="/finance"
        element={<AuthenticationGuard component={FinanceAmount} />}
      />
      <Route
        path="/upload-documents"
        element={<AuthenticationGuard component={UploadDocuments} />}
      />
      <Route
        path="/summary"
        element={<AuthenticationGuard component={TransactionSummary} />}
      />
      <Route
        path="/confirmation"
        element={<AuthenticationGuard component={Confirmation} />}
      />
      <Route
        path="/payments"
        element={<AuthenticationGuard component={Payments} />}
      />
      <Route path="/signup" Component={DealershipSignup} />
      <Route path="/loan-data" Component={LoanData} />
      <Route path="/guest-loan-details" Component={GuestLoanDeatils} />
      <Route
        path="/payments/:transactionId/draft"
        element={<AuthenticationGuard component={DraftingInstructions} />}
      />
    </Routes>
  );

  return (
    <div className="App">
      <Auth0TokenMiddleware />
      {shouldHideNavbar ? routes : <Navbar>{routes}</Navbar>}
    </div>
  );
}

export default App;
